import { Component } from '@angular/core';
import { DialogSize } from '@anduin/shared';

@Component({
  selector: 'app-chunk-error-dialog',
  templateUrl: './chunk-error-dialog.component.html',
  styleUrls: ['./chunk-error-dialog.component.scss'],
  standalone: false,
})
export class ChunkErrorDialogComponent {
  dialogSize = DialogSize.SMALL;
}
